/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import user from './user/saga';
import upload from './upload/saga';
import validation_document_review from './validation_document_review/saga';
import equipment_schedule_maintenance from './equipment_schedule_maintenance/saga';
import request from './request/saga';
import request_detail from './request_detail/saga';
import task from './task/saga';
import task_equipment from './task_equipment/saga';
import search from './search/saga';
import award from './award/saga';
import award_detail from './award_detail/saga';
import delivery_plan from './delivery_plan/saga';
import vehicle from './vehicle/saga';
import employee from './employee/saga';
import task_employee from './task_employee/saga';
import task_vehicle from './task_vehicle/saga';
import ambulance from './ambulance/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    user(),
    upload(),
    validation_document_review(),
    equipment_schedule_maintenance(),
    request(),
    request_detail(),
    task(),
    task_equipment(),
    search(),
    award(),
    award_detail(),
    delivery_plan(),
    vehicle(),
    employee(),
    task_employee(),
    task_vehicle(),
    ambulance()
  ]);
}
